export const HUMAN_LEGIBLE_DEFAULT_HELP_HOTLINE = '(833) 609-1160';
export const DEFAULT_HELP_HOTLINE = '8336091160';

export const MAIN_CONTENT_ID = 'main-content-id';

export enum BlendURLIndicator {
    BLEND_SSO = '/mortgage/sso/saml/login',
    SAML_AUTHN = 'saml-authn',
    BLEND_ACTIVATE = 'activate',
    BLEND_DIRECT = 'blendlabs',
}

/**
 * Contains all routes for our application experiences
 * ! Careful changing these routes, as the blast radius is huge
 */
export enum ApplicationRoute {
    AUTH_LOGIN = '/homeloans/mortgage/auth/login',
    AUTH_ERROR = '/homeloans/mortgage/auth/error',
    DASHBOARD = '/homeloans/mortgage/dashboard',
    DASHBOARD_BOUNCE = '/homeloans/mortgage/dashboard/login',
    ACTIVATE = '/homeloans/mortgage/dashboard/activate',
    ACTIVATE_FAILURE = '/homeloans/mortgage/dashboard/activation-failure',
    AUTH_SIGNIN_BOUNCE = '/homeloans/mortgage/auth/signin',
    CALLBACK_SCHEDULER = '/homeloans/mortgage/schedule-callback',
    CALLBACK_SCHEDULER_SUCCESS = '/homeloans/mortgage/schedule-callback/success',
    CALLBACK_SCHEDULER_FAILURE = '/homeloans/mortgage/schedule-callback/failure',
    CALLBACK_SCHEDULER_ERROR = '/homeloans/mortgage/schedule-callback/error',
    BLEND_AUTH_TELEMETRY = '/homeloans/mortgage/auth/blend',
    API_BASE = '/homeloans/mortgage/api',
    PREFIXED_GRAPHQL_ENDPOINT = '/homeloans/mortgage/api/graphql',

    PREFIXLESS_GRAPHQL_ENDPOINT = '/api/mortgage/graphql',
}

/**
 * Known destination routes on services other than MAC Web
 */
export enum ExternalRoute {
    DIGITAL_PREAPPROVAL_APPLICATION = '/homeloans/verify',
    PREQUAL_FUNNEL = '/homeloans/eligibility',
    HOMELOANS_LANDING_PAGE = '/homeloans/',
    UNIVERSAL_LOGOUT = '/Logout.htm',
}

export enum ZillowDomain {
    NON_PROD = 'https://www.qa.zillow.net',
    PROD = 'https://www.zillow.com',
}

export enum ZHLDomain {
    DEVELOPMENT = 'https://www.dev.zillowhomeloans.net',
    STAGING = 'https://www.staging.zillowhomeloans.net',
    PROD = 'https://www.zillowhomeloans.com',
}

export enum STORYBOOK_CONSTELLATION_VIEWPORTS {
    XS = 'constellationXs',
    SM = 'constellationSmMax',
    MD = 'constellationMdMax',
    LG = 'constellationLgMax',
    XL = 'constellationXlMax',
}

export const CYPRESS_INTEGRATION_TEST_IDS = {
    DEVELOPMENT_TOOLS: {
        GO_TO_MORTGAGE_DASHBOARD: 'go-to-mortgage-dashboard',
        GO_TO_APPLICATION_DASHBOARD: 'go-to-application-dashboard',
        CREATE_LOAN_APPLICATION_FOR_ACCOUNT: 'create-loan-application-for-account',
    },
    ABAD: {
        modal: 'abad-modal',
        header: 'abad-conversational-heading',
        centeredHeading: 'abad-title-heading',
        abadContent: 'abad-content',
        closeButton: 'abad-dismiss-button',
    },
    MOLECULAR: {
        CONFIRMATION_DIALOG: {
            MODAL: 'molecular-confirmation-dialog-modal',
            HEADER: 'molecular-confirmation-dialog-header',
            BODY: 'molecular-confirmation-dialog-body',
            CONFIRM_BUTTON: 'molecular-confirmation-dialog-confirm',
            CANCEL_BUTTON: 'molecular-confirmation-dialog-cancel',
        },
    },
    MORTGAGE_DASHBOARD: {
        HERO_IMAGE: 'mortgage-dashboard-hero-image',
        PAGE: 'mortgage-dashboard',
        EXPERIENCES: {
            NEW_APPLICATION: {
                RESOURCE_CARD: {
                    TITLE: 'landing-experience-info-heading',
                    CTA: 'landing-experience-info-cta',
                    MODAL: 'landing-modal-heading',
                    MODAL_CTA: 'landing-modal-cta',
                },
                UPSELL: {
                    TEXT: 'landing-experience-header',
                    CTA: 'landing-experience-hero-cta',
                    PHONE_CALL_LINK: 'landing-experience-phone',
                },
            },
            OUTSTANDING_TASKS: {
                RESOURCE_CARD: {
                    TITLE: 'offer-accepted-info-heading',
                    CTA: 'offer-accepted-info-cta',
                    MODAL: 'offer-accepted-modal-heading',
                },
                UPSELL: {
                    TITLE: 'offer-accepted-experience-header',
                    TEXT: 'offer-accepted-experience-text',
                    CTA: 'offer-accepted-experience-cta',
                },
            },
            VERIFIED_PRE_APPROVAL: {
                RESOURCE_CARD: {
                    TITLE: 'pre-approval-info-heading',
                    CTA: 'pre-approval-info-cta',
                    MODAL: 'pre-approval-modal-heading',
                    MODAL_CTA: 'pre-approval-modal-cta',
                },
                UPSELL: {
                    TEXT: 'pre-approval-experience-heading',
                    CTA: 'pre-approval-experience-cta',
                    MODAL: 'pre-approval-experience-modal-heading',
                },
            },
            DIGITAL_PREAPPROVAL_VERIFIED_PRE_APPROVAL: {
                UPSELL: {
                    TEXT: 'digital-pre-approval-verified-pre-approval-experience-heading',
                    CTA: 'digital-pre-approval-verified-pre-approval-experience-cta',
                    MODAL: 'digital-pre-approval-verified-pre-approval-experience-modal-heading',
                },
            },
            DIGITAL_PREAPPROVAL_VERIFIED_OUTSTANDING_TASKS: {
                UPSELL: {
                    TEXT: 'digital-pre-approval-verified-pre-approval-with-tasks-experience-heading',
                    CTA: 'digital-pre-approval-verified-pre-approval-with-tasks-experience-cta',
                    SECONDARY_CTA: 'digital-pre-approval-verified-pre-approval-with-tasks-experience-secondary-cta',
                    MODAL: 'digital-pre-approval-verified-pre-approval-with-tasks-experience-modal-heading',
                },
            },
            WAITING_TO_CLOSE: {
                UPSELL: {
                    TEXT: 'waiting-experience-heading',
                },
                RESOURCE_CARD: {
                    TITLE: 'waiting-info-heading',
                    CTA: 'waiting-info-cta',
                    MODAL: 'waiting-modal-heading',
                },
            },
        },
        VIEW_SAVED_INFORMATION: {
            CTA: 'access-your-info-cta',
        },
        RESOURCE_CARD_MODAL: 'resource-card-modal',
        ZDOCS_DOCUMENT_VIEWER: {
            MODAL: 'zdocs-document-viewer-modal',
            MODAL_FRAME: 'zdocs-document-view-modal-frame',
            MODAL_BANNER: 'zdocs-document-viewer-modal-banner',
            DOWNLOAD_BUTTON: 'zdocs-document-viewer-download-button',
            MOBILE_DOWNLOAD_BUTTON: 'zdocs-document-viewer-download-button-mobile',
            PRINT_BUTTON: 'zdocs-document-viewer-print-button',
            SHARE_BUTTON: 'zdocs-document-viewer-share-button',
        },
        WELCOME_BANNER: {
            BANNER: 'welcome-banner',
        },
        YOUR_TEAM_CARD: {
            GENERIC_HOTLINE: 'generic-hotline',
            FULL_NAME: 'assigned-team-member-full-name',
            TITLE: 'assigned-team-member-title',
            PHONE: 'assigned-team-member-phone',
            EMAIL: 'assigned-team-member-email',
        },
        ERROR_PAGE: {
            ACTIVATION_FAILURE_HEADER: 'activation-failure-header',
            ACTIVATION_FAILURE_MESSAGE: 'activation-error-message',
        },
    },
    DASHBOARD_LINK: 'navbar-dashboard',
    CALLBACK_SCHEDULER: {
        SCHEDULE_APPOINTMENT_BUTTON: 'callback-scheduler-schedule-appointment-button',
        EXPERIENCES: {
            SUCCESS: {
                HEADING: 'callback-scheduler-success-heading',
                SCHEDULER_CX_HELP_HOTLINE_NUMBER: 'callback-scheduler-success-help-hotline-number',
                DASHBOARD_REDIRECT: 'callback-scheduler-success-dashboard-redirect',
                DPA_REDIRECT: 'callback-scheduler-success-dpa-redirect',
            },
            FAILURE: {
                HEADING: 'callback-scheduler-failure-heading',
                BUTTON: {
                    GET_PREAPPROVAL_CTA: 'callback-scheduler-failure-get-preapproval-cta',
                    DASHBOARD_CTA: 'callback-scheduler-failure-dashboard-cta',
                },
            },
        },
        TIMEZONE_SELECTOR: 'callback-scheduler-timezone-selector',
        HOUR_PICKER: {
            LOADING_OVERLAY: 'callback-scheduler-hour-picker-loading-overlay',
            HOUR_BUTTONS: 'callback-scheduler-hour-picker-hour-buttons',

            MORNING_TAB: 'callback-scheduler-hour-picker-morning-tab',
            AFTERNOON_TAB: 'callback-scheduler-hour-picker-afternoon-tab',
        },
        CAROUSEL: {
            LEFT_BUTTON: 'callback-scheduler-carousel-left-button',
            RIGHT_BUTTON: 'callback-scheduler-carousel-right-button',
            DAY_BUTTON: {
                ELEMENT: 'callback-scheduler-carousel-day-button',
                MONTH_DAY_LABEL: 'callback-scheduler-carousel-day-button-month-day-label',
            },
        },
    },
} as const;

export enum ERROR_PREFIXES {
    APOLLO = '[APOLLO]',
    ANALYTICS = '[ANALYTICS]',
    DASHBOARD = '[DASHBOARD]',
    APPLICATION_SESSION = '[APPLICATION SESSION]',
    OAUTH = '[OAUTH]',
    PUBLIC_SETTINGS_API = '[Public Settings API]',
    MAX_API = '[MAX API]',
}

export const CYPRESS_ID_ATTRIBUTE = 'data-testid';
/**
 * Allows for identification of origin based one minimal identifying subset of the origin string
 */
export enum OriginIdentifier {
    // covers zillowhomeloans.com, dev.zillowhomeloans.net, and staging.zillowhomeloans.net
    ZILLOW_HOME_LOANS = 'zillowhomeloans',
    // covers qa.zillow.com, zillow.com. The period is important to distinguish it from zillow-dev-k8s or zillow-test-k8s
    ZILLOW = 'zillow.',
    LOCALHOST = 'localhost',
    ZGCP = 'zhl-mortgage-application-center-web-',
}

export enum TIME_UNITS {
    MILLISECONDS_IN_SECOND = 1000,
    MILLISECONDS_IN_MINUTE = 60_000,
    MILLISECONDS_IN_HOUR = 3_600_000,
    ONE_SECOND = 1,
    SECONDS_IN_MINUTE = 60,
    MINUTES_IN_HOUR = 60,
    HOURS_IN_DAY = 24,
    DAYS_IN_YEAR = 365,
}
